export default "__VITE_ASSET__37f942c5__"